window.addEventListener("DOMContentLoaded", function () {
  setTimeout(AddSize, 1500);
  setTimeout(productCus, 2000);
  setTimeout(Addinfo, 1000);
  setTimeout(allowInput, 1000);
  setTimeout(Txtinput, 2000);
 setTimeout(changeState, 2000);
    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
    makeupTheDifferenceQty = getUrlParam('_amount');
  }
  if (makeupTheDifferenceQty != null) {
    $("input[name='quantity']").val(makeupTheDifferenceQty);
  }
      var isTypeurl = window.location.href;//判断是否是详情页
  if(isTypeurl == 'https://www.fanscustom.com/collections/custom-baseball-jerseys'){
    window.location.href = 'https://www.fanscustom.com/collections/baseball-hot-sale';
  }
      if(isTypeurl.indexOf('products')!=-1){

        var goods_name = $.trim($('h1.t4s-product__title').text());
        add_button(goods_name);
        if(goods_name =='Make Up The Price Difference'){   
          $('.flickityt4s-slider li ,.t4s-tabs .t4s-tab-wrapper').eq(1).css('cssText','display: none !important;')
        } 

      var interval2 = setInterval(()=>{
        if($('#customized_bigtur').length>0){
            setTimeout($('#product-add-to-cart').removeAttr('style'), 2000);
            setTimeout($('#product-add-to-cart').parent('.add_div').removeAttr('style'), 2000);
            $('.question_buttons').bind({click: function () {
            $(this).parents('.bigtur_wrapper').find('.bubble.tip-top').stop(true, true).slideDown();
        }
        });
          clearInterval(interval2);
          
        }
      }, 1500);  
 } 


  $(".mi-close").click(function () {
    $("#mask-mi,.mi-popup-kk").css("display", "none");
  });
  $("#mask-mi").click(function () {
    $(this).css("display", "none");
    $("#mi-popup-kk").css("display", "none");
  });
  $(".size-cm").click(function () {
    $(this).addClass("size_checked");
    $("#inTable").addClass("size_hidden");
    $("#cmTable").removeClass("size_hidden");
    $(".size-in").removeClass("size_checked");
  });

  $(".size-in").click(function () {
    $(this).addClass("size_checked");
    $("#cmTable").addClass("size_hidden");
    $("#inTable").removeClass("size_hidden");
    $(".size-cm").removeClass("size_checked");
  });

  var interval1 = setInterval(() => {
    var Nickname = $('input[name="properties[Nickname]"]');
    var Names = $(
      'input[name="properties[Kids & Grandkids Names(Up To 25 And Between 2 Kids By Commas)]"]'
    );
    if (Nickname && Names) {
      Nickname.attr(
        "placeholder",
        "Enter Any Nickname Here (e.g. Papa, Grandpa, Pops, Poppy, etc.)"
      );
      Names.attr(
        "placeholder",
        "Enter Names Here ( e.g. Logan, Eli, Bella etc. )"
      );
      clearInterval(interval1);
    }
  }, 100);

  // 工艺tab 切换
    // Variables
  var clickedTab = $(".tabs > .active");
  var tabWrapper = $(".tab__content");
  var activeTab = tabWrapper.find(".active");
  var activeTabHeight = activeTab.outerHeight();

  // Show tab on page load
  activeTab.show();

  $(".tabs > li").on("click", function () {
    // Remove class from active tab
    $(".tabs > li").removeClass("active");

    // Add class active to clicked tab
    $(this).addClass("active");

    // Update clickedTab variable
    clickedTab = $(".tabs .active");

    // fade out active tab
    activeTab.fadeOut(250, function () {

      // Remove active class all tabs
      $(".tab__content > li").removeClass("active");

      // Get index of clicked tab
      var clickedTabIndex = clickedTab.index();
      // Add class active to corresponding tab
      $(".tab__content > li").eq(clickedTabIndex).addClass("active");

      // update new active tab
      activeTab = $(".tab__content > .active");

      // Update variable
      activeTabHeight = activeTab.outerHeight();
      // Animate height of wrapper to new tab height
      tabWrapper.stop().delay(5).animate({
        height: activeTabHeight },
      5, function () {

        // Fade in active tab
        activeTab.delay(5).fadeIn(250);
        
      });
      $("#mi-popup-kk").animate({"scrollTop":0},200);
      
    });
  });

  // Variables
  var colorButton = $(".colors li");

  colorButton.on("click", function () {

    // Remove class from currently active button
    $(".colors > li").removeClass("active-color");

    // Add class active to clicked button
    $(this).addClass("active-color");

    // Get background color of clicked
    var newColor = $(this).attr("data-color");

    // Change background of everything with class .bg-color
    $(".bg-color").css("background-color", newColor);

    // Change color of everything with class .text-color
    $(".text-color").css("color", newColor);
  });

  // 商品详情页 评论星 点击链接到评论
  $('.loox-rating').bind({click:function(e){
     $([document.documentElement, document.body]).animate({
        scrollTop: ($("#looxReviews").offset().top)-80
    }, 1000);
    }});

    var screenWidth = screen.width;
    var screenHeight = screen.height;
    var windowWidth = $(window).width();
    var windowHeight = $(window).height(); 
});

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

  function changeState(){
    setTimeout($('[name="checkout"]').removeAttr("disabled"), 1500);
    var property =  $('.t4s-cart_meta_propertyList').find('.product-details__item-label').next();
    var is_price = false;
      property.each(function(){
       if($(this).html().indexOf('| $') >-1 ){
          is_price = true;    
         return false;
       }
      });
  if(is_price == true){
      var interval2 = setInterval(()=>{
         var line_price  = $('.bcpo-cart-item-line-price').find('span');
        line_price.each(function(){
         if($(this).attr('data-usd') !=undefined){
             setTimeout($('[name="checkout"]').removeAttr("disabled"), 1500);
             clearInterval(interval2);
           return false;       
         }
          }); 
     },1000) 
  }else{
     setTimeout($('[name="checkout"]').removeAttr("disabled"), 1500);
   
  }
}

function AddSize() {
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_default'],div[class='t4s-swatch__option is-t4s-name__size']");
  var modal =
    '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display:inline-block;"><span class="icon-f-09"></span> Size guide</a>';
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(AddSize, 1000);
  } else {
    obj.each(function () {
      if(obj.find('.bigtur_title').text().indexOf('Size')>-1){
        $(this).find(".t4s-swatch__title").append(modal);
       $(this).find(".bigtur_div_extend").append(modal);
      }else{
        obj.show()
        obj.find('select').removeAttr('disabled')
      }

    });
  }
}

function Txtinput()
{
    var _title=$('h1.t4s-product__title').text();
    var regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？！…―——_'"^%#@\·~&<>《》$=()+-/*{}[\]]|(^\s*)/g;
    if(_title.indexOf('Hat') !== -1){
        var regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z]/g;
    }

    if($("input[name='properties[Back Number]']").attr("data-price")!=null)
    {
        //         不允许输入“|”
        $("input[type='text']").keyup(function(){
            if($(this).val().indexOf("|") != -1){
                $(this).val("");
            }
        });
        // 判断是ios还是安卓
        if (ios_or_android() == 'ios') {
            $("input[type='text']").on("keyup", function(){
                var param = $(this).val();
                $(this).val(param.replace(regRule,""));
            })
        } else {
            $("input[type='text']").on("input", function(){
                var param = $(this).val();
                $(this).val(param.replace(regRule,""));
            })
        }
    }else
    {
        setTimeout(Txtinput,3000);
    }
}

function getFileName(path) {
  var pos1 = path.lastIndexOf("/");
  var pos2 = path.lastIndexOf("\\");
  var pos = Math.max(pos1, pos2);
  if (pos < 0) {
    return path;
  } else {
    return path.substring(pos + 1);
  }
}

/*
        @功能：判断终端是ios还是安卓
         */
function ios_or_android() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if (isAndroid) {
    return "and";
  } else {
    return "ios";
  }
}

function productCus() {
  var _upload = $("input[name='properties[Upload Logo]'],input[name='properties[Team Logo]'],input[name='properties[Upload Photo]']");
  if (_upload.attr("data-price") != null) {
    _upload.attr("accept", "image/png, image/jpeg,image/jpg");
    if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
      $("span[class='bigtur_title']").each(function () {
        var htm = $(this).html();
        var title = $(this).text();

        if (htm.indexOf("*") > -1) {
          htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: middle;'>*</span>");
          $(this).html(htm);
        }


        if (htm.indexOf("Team Logo") > -1 || htm.indexOf("Back Logo") > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
          htm ='<font size="-2">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>';
          $(this).append(htm);
        }else if($(this).parents('.bigtur_simple ').find('textarea').length == 1){
          if(htm.indexOf("Text 1") > -1){
            html2 = "DAD <br> YOU'RE OUR <br> HOME RUN"
          }else if(htm.indexOf("Age") > -1 ||  htm.indexOf("Time") > -1){
                   html2 = "1984 <br> 40"
          }else if(htm.indexOf("Year") > -1){
                   html2 = "1974 <br> 50"
          }
         $(this).parents('.bigtur_simple ').find('.bigtur_div_extend').addClass('active').html(html2)
        $(this).parents('.bigtur_simple ').find('textarea').bind('input propertychange', function() {
            var textareaValue = $(this).val().trim();
            if (textareaValue === '') {
             $(this).next('div').html(html2)
              } else {
               $(this).next('div').empty()
             }
            });
        }else if(htm.indexOf("Text") > -1 && $(this).parents('.bigtur_simple ').find('textarea').length == 1){
         $(this).parents('.bigtur_simple ').find('.bigtur_div_extend').addClass('active').html("HAPPY <br> Grandparents <br> DAY")

        $(this).parents('.bigtur_simple ').find('textarea').bind('input propertychange', function() {
            var textareaValue = $(this).val().trim();
            if (textareaValue === '') {
             $(this).next('div').html("HAPPY <br> Grandparents <br> DAY")
              } else {
               $(this).next('div').empty()
             }
            });
        }
      });
    }
  } else {
    setTimeout(productCus, 3000);
  }
}

function Addinfo() {
  var mi = $('input[type=radio][name="properties[Material]"]')
    .parent()
    .parent()
    .prev();
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_buttons']");
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(Addinfo, 1000);
  } else {
    mi.append(
      '<a href="javascript:void(0);" class="scmi" style="color:red;margin-bottom: 10px;display: inline-block;" onclick="ClickMi()">&nbsp; Instruction<a/>'
    );
  }
}


function allowInput(){
    var obj=$("div[class='bigtur_wrapper bigtur_simple bigtur_text']");
    obj.each(function(){
        var inputname = $(this).find("input").attr("name");
        var inputlength = $(this).find("input").attr("maxlength");
        $("input[name='"+inputname+"']").attr("placeholder","Optional");
        $("input[name='"+inputname+"']").after("<span class='allow_input' style='display:none;'><span></span> Left</span>");
        showLeftInput(inputname,inputlength);
    });
}



//   显示剩余可输入字符数
function showLeftInput(inputname,totalchars){
    $(".allow_input").nextAll().remove();
    $("input[name='"+inputname+"']").keyup(function(){
        var thischars = this.value.replace(/{.*}/g, '').length;
        $(this).next().show();
        if (thischars > totalchars) {
            var CharsToDel = (thischars - totalchars);
            this.value = this.value.substring(0, this.value.length - CharsToDel);
        }else{
            $(this).next().children("span").text(totalchars - thischars);
        }
    });
}




function ClickMi() {
  $("#mask-mi").show();

  var $Popup = $(".mi-popup-kk");
  $Popup.css({
    left: ($("body").width() - $Popup.width()) / 2 + "px",
    display: "block",
    position: "fixed",
  });

}

function add_button(goods_name) {
    $('#product-add-to-cart').bind({
        click: function () {
            if (goods_name != 'Make Up The Price Difference' && goods_name != 'Get Awesome Free Sample Only  Shipping Fee Requried') {
              console.log('2222')
                if ($('#customized_bigtur').length < 1) {
                    alert('Product customization information failed to load, please refresh the page and add to the shopping cart again!');
                    return false;
                } else {
                    var text = $('#customized_bigtur').find('input[type="text"]').parent();
                    var Material = $('input[value="Blank(No Name/Number)"]');
                    if ($('#customized_bigtur').find('input[type="file"]').length > 0) {
                        var fileInput = $('#customized_bigtur').find('input[type="file"]').get(0).files[0];
                    }
                    if(Material.is(":checked") == false && Material.length >0){
                         is_hide = Blank_hide()
                        if (is_hide) {
                            $('#customized_bigtur').find('input[type="text"]').attr("disabled", true);
                            $('input[value="Blank(No Name/Number)"]').trigger("click");
                        }
                    }
                }
            }
        }
    });
}
